import React from 'react';
import { useLocation } from 'react-router';
import { Icons } from '../base/BootstrapComponents/BootstrapComponents';
import Tooltip from '../base/Tooltip/Tooltip';

export default function LayoutLegend({ onHide = () => {} }) {
  const location = useLocation();
  const isGeography = location.pathname.includes('geography');
  return (
    <div className="help-block">
      <Tooltip
        className="tbl"
        tooltipContent={(
          <div className="helper-tooltip">
            <div className="pmh-block">
              <div className="pmh-title">Легенда</div>
              <div className="pmh-table">
                <div className="pmh-column">
                  <div className="pmh-column-title">Значение иконок</div>
                  <div className="pmh-data-row">
                    <div className="legend-icon-block">
                      <div className="legend-icon">
                        <Icons icon="update-period-30" customIcon />
                      </div>
                      Обновление данных
                    </div>
                  </div>
                  <div className="pmh-data-row">
                    <div className="legend-icon-block">
                      <div className="legend-icon">
                        <Icons icon="glasses" customIcon />
                      </div>
                      Версия для слабовидящих
                    </div>
                  </div>
                  <div className="pmh-data-row">
                    <div className="legend-icon-block">
                      <div className="legend-icon">
                        <Icons icon="plus" customIcon />
                      </div>
                      Создать запись
                    </div>
                  </div>
                  <div className="pmh-data-row">
                    <div className="legend-icon-block">
                      <div className="legend-icon">
                        <Icons icon="gear" customIcon />
                      </div>
                      Настроить колонки в таблице
                    </div>
                  </div>
                  {
                    isGeography ? (
                      <div className="pmh-data-row">
                        <div className="legend-icon-block">
                          <div className="legend-icon">
                            <div className="map-marker" />
                          </div>
                          Актуальная телеметрия СИМ
                        </div>
                      </div>
                    ) : null
                  }
                </div>
              </div>
            </div>
          </div>
        )}
        content={<Icons customIcon className="help-icon" icon="help" />}
      />
    </div>
  );
}
